/* EcomHub Pro — TrustPilot Testimonials slider engine */
(function () {
  var mqMobile = window.matchMedia('(max-width: 749px)');

  function init(root) {
    if (root.__ehpFon) return;
    root.__ehpFon = true;

    var section = root.closest('.ehp-fon') || root;
    var viewport = root.querySelector('.ehp-fon__viewport');
    var track = root.querySelector('.ehp-fon__track');
    var dotsWrap = root.querySelector('.ehp-fon__dots');
    if (!viewport || !track) return;

    var slides = Array.prototype.slice.call(track.children);
    var prevBtns = root.querySelectorAll('[data-ehp-prev]');
    var nextBtns = root.querySelectorAll('[data-ehp-next]');

    var autoplay = root.dataset.autoplay === '1';
    var autoplayType = root.dataset.autoplayType || 'classic';
    var autoplayDir = root.dataset.autoplayDir === 'left' ? -1 : 1;
    var autoplaySpeed = (parseFloat(root.dataset.autoplaySpeed) || 4) * 1000;

    var index = 0;
    var timer = null;
    var currentDir = 1;
    var pos = 0, cloned = false, dotIdx = 0;

    function looping() { return autoplay && autoplayType === 'infinite' && !isStatic() && overflowing(); }
    function loopWidth() { return slides.length * slideStep(); }
    function loopSteps() { return Math.max(1, Math.ceil(slides.length / scrollAmt())); }
    function setPos(p, animate) {
      pos = p;
      if (animate === false) { track.style.transition = 'none'; }
      track.style.transform = 'translateX(' + -pos + 'px)';
      if (animate === false) { void track.offsetWidth; track.style.transition = ''; }
    }
    function ensureClones() {
      if (cloned) return;
      var frag = document.createDocumentFragment();
      slides.forEach(function (sl) {
        var c = sl.cloneNode(true);
        c.setAttribute('aria-hidden', 'true');
        c.removeAttribute('id');
        frag.appendChild(c);
      });
      track.appendChild(frag);
      cloned = true;
    }
    function removeClones() {
      if (!cloned) return;
      while (track.children.length > slides.length) track.removeChild(track.lastChild);
      cloned = false;
    }
    /* endless one-direction rotation: the cloned set makes the first card follow the last,
       and we snap back by exactly one loop width (invisible, identical content) before moving */
    function rotate(dir) {
      var lw = loopWidth(), step = scrollAmt() * slideStep();
      if (lw <= 0 || step <= 0) return;
      if (dir > 0 && pos >= lw) setPos(pos - lw, false);
      else if (dir < 0 && pos - step < 0) setPos(pos + lw, false);
      setPos(pos + dir * step, true);
      dotIdx = (dotIdx + dir + loopSteps()) % loopSteps();
      syncDots();
    }

    function scrollAmt() {
      var v = mqMobile.matches ? parseInt(root.dataset.scrollM, 10) : parseInt(root.dataset.scroll, 10);
      return Math.max(1, v || 1);
    }
    function cols() {
      var c = mqMobile.matches ? parseInt(root.dataset.colsM, 10) || 1 : parseInt(root.dataset.cols, 10) || 1;
      return Math.max(1, Math.min(c, slides.length));
    }
    function isStatic() {
      return mqMobile.matches ? root.dataset.sliderM !== '1' : root.dataset.slider !== '1';
    }
    function slideStep() {
      if (!slides.length) return 0;
      var w = slides[0].getBoundingClientRect().width;
      var cs = getComputedStyle(track);
      var gap = parseFloat(cs.columnGap || cs.gap) || 0;
      return w + gap;
    }
    function contentWidth() {
      var st = slideStep();
      if (!st) return 0;
      var cs = getComputedStyle(track);
      var gap = parseFloat(cs.columnGap || cs.gap) || 0;
      return slides.length * st - gap;
    }
    function maxScroll() {
      return Math.max(0, contentWidth() - viewport.clientWidth);
    }
    function overflowing() {
      return maxScroll() > 1;
    }
    function maxIndexSlides() {
      var st = slideStep();
      if (st <= 0) return 0;
      return Math.max(0, Math.ceil(maxScroll() / st));
    }
    function currentPos() {
      return Math.min(Math.max(index * slideStep(), 0), maxScroll());
    }
    function pageStep() { return slideStep() * scrollAmt(); }
    function pages() {
      var ps = pageStep();
      if (ps <= 0) return 1;
      return Math.max(1, Math.ceil(maxScroll() / ps) + 1);
    }
    function currentPage() {
      var ps = pageStep();
      if (ps <= 0) return 0;
      return Math.round(currentPos() / ps);
    }

    function paint(animate) {
      if (isStatic() || !overflowing()) { track.style.transform = ''; return; }
      if (animate === false) { track.style.transition = 'none'; void track.offsetWidth; }
      track.style.transform = 'translateX(' + -currentPos() + 'px)';
      if (animate === false) { void track.offsetWidth; track.style.transition = ''; }
    }

    function go(i, animate) {
      var max = maxIndexSlides();
      if (i < 0) i = 0;
      if (i > max) i = max;
      index = i;
      paint(animate);
      syncDots();
      syncArrows();
    }
    function next() { if (looping()) { rotate(1); return; } go(index + scrollAmt()); }
    function prev() { if (looping()) { rotate(-1); return; } go(index - scrollAmt()); }

    function buildDots() {
      if (!dotsWrap) return;
      /* ⚠️ DO NOT TEAR THE DOTS DOWN IF THE COUNT HAS NOT CHANGED. This used to
         wipe innerHTML and rebuild every time refresh() ran, which RESTARTS the
         CSS width transition on the active pill from scratch — the dots visibly
         flashed and jumped. Combined with refresh() firing on every resize (see
         the resize handler below), scrolling on a phone rebuilt them constantly. */
      var wantTotal = (!overflowing() || isStatic()) ? 0 : (looping() ? loopSteps() : pages());
      if (dotsWrap.children.length === wantTotal && wantTotal > 0) { syncDots(); return; }
      dotsWrap.innerHTML = '';
      if (!overflowing() || isStatic()) return;
      var total = looping() ? loopSteps() : pages();
      for (var p = 0; p < total; p++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'ehp-fon__dot';
        b.setAttribute('aria-label', 'Go to slide group ' + (p + 1));
        (function (page) {
          b.addEventListener('click', function () {
            if (looping()) { setPos(page * scrollAmt() * slideStep(), true); dotIdx = page; syncDots(); }
            else go(page * scrollAmt());
            restart();
          });
        })(p);
        dotsWrap.appendChild(b);
      }
      syncDots();
    }
    function syncDots() {
      if (!dotsWrap) return;
      /* ⚠️⚠️⚠️ THE ACTIVE DOT IS DERIVED FROM THE REAL POSITION, NOT A COUNTER.
         In loop mode this used `dotIdx`, a separate counter incremented in
         rotate(). But rotate() also SNAPS the track back by one loop width when
         it passes the end, and the counter and the snap are maintained
         independently — so after a full cycle they drift apart and the
         highlighted dot stops matching the slide on screen (in my capture the
         highlight got stuck on the first dot while the track kept moving).
         Reading it back off `pos` means there is only one source of truth and
         they cannot desync, however many cycles it runs. */
      var kids = dotsWrap.children, active;
      if (looping()) {
        var dstep = scrollAmt() * slideStep(), dn = loopSteps();
        active = dstep > 0 && dn > 0 ? ((Math.round(pos / dstep) % dn) + dn) % dn : 0;
      } else {
        active = currentPage();
      }
      for (var i = 0; i < kids.length; i++) kids[i].classList.toggle('is-active', i === active);
    }
    function syncArrows() {
      var loop = autoplayType === 'infinite';
      var atStart = currentPos() <= 0.5;
      var atEnd = currentPos() >= maxScroll() - 0.5;
      [].forEach.call(prevBtns, function (b) { b.disabled = atStart && !loop; });
      [].forEach.call(nextBtns, function (b) { b.disabled = atEnd && !loop; });
    }

    function tick() {
      if (looping()) { rotate(currentDir); return; }
      // classic: step until the far edge, then stop (respects direction)
      if (currentDir > 0 && currentPos() >= maxScroll() - 0.5) { stop(); return; }
      if (currentDir < 0 && currentPos() <= 0.5) { stop(); return; }
      go(index + currentDir * scrollAmt());
    }
    function play() {
      stop();
      if (!autoplay || isStatic() || !overflowing()) return;
      currentDir = autoplayDir;
      timer = setInterval(tick, autoplaySpeed);
    }
    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
    }
    function restart() { if (autoplay) play(); }

    [].forEach.call(prevBtns, function (b) { b.addEventListener('click', function () { prev(); restart(); }); });
    [].forEach.call(nextBtns, function (b) { b.addEventListener('click', function () { next(); restart(); }); });

    /* ⚠️ HOVER-PAUSE MUST NOT APPLY TO TOUCH. A tap on a phone fires mouseenter
       and often never fires mouseleave, which stopped autoplay permanently
       after the first touch — a large part of "buggy on a published store".
       Bind it only where a real pointer can hover. */
    if (!window.matchMedia || window.matchMedia('(hover: hover)').matches) {
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', play);
    }

    /* swipe / drag — on touch devices gated by the "enable swipe" toggle; mouse always drags */
    var dragX = 0, dragging = false, startTx = 0;
    function canSwipe() {
      if (isStatic() || !overflowing()) return false;
      return root.dataset.swipe === '1';
    }
    viewport.addEventListener('pointerdown', function (e) {
      if (!canSwipe()) return;
      dragging = true; dragX = e.clientX; startTx = looping() ? -pos : -currentPos();
      root.classList.add('ehp-fon__grabbing'); stop();
    });
    window.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      track.style.transform = 'translateX(' + (startTx + (e.clientX - dragX)) + 'px)';
    });
    window.addEventListener('pointerup', function (e) {
      if (!dragging) return;
      dragging = false;
      root.classList.remove('ehp-fon__grabbing');
      var dx = e.clientX - dragX, threshold = slideStep() * 0.25;
      if (dx <= -threshold) next();
      else if (dx >= threshold) prev();
      else if (looping()) setPos(pos, true);
      else go(index);
      restart();
    });

    function refresh() {
      section.classList.toggle('ehp-fon--nonav', isStatic() || !overflowing());
      if (looping()) {
        ensureClones();
        dotIdx = 0;
        buildDots();
        setPos(0, false);
        syncArrows();
      } else {
        removeClones();
        if (index > maxIndexSlides()) index = maxIndexSlides();
        buildDots();
        go(index, false);
      }
      play();
    }

    var rt;
    /* ⚠️⚠️⚠️ THIS IS WHY IT "RESETS WHEN YOU SCROLL BACK UP". refresh() re-measures
       and snaps the track back to the start, and it was wired to EVERY resize
       event. On a phone, scrolling hides and shows the browser's address bar,
       which changes the viewport HEIGHT and fires resize — so ordinary scrolling
       kept restarting the carousel. Nothing about a height change affects a
       horizontal carousel's measurements, so only react when the WIDTH moves. */
    var lastW = window.innerWidth;
    window.addEventListener('resize', function () {
      if (window.innerWidth === lastW) return;
      lastW = window.innerWidth;
      clearTimeout(rt);
      rt = setTimeout(refresh, 150);
    });
    window.addEventListener('orientationchange', function () {
      lastW = window.innerWidth;
      clearTimeout(rt);
      rt = setTimeout(refresh, 250);
    });

    /* ⚠️ AUTOPLAY OFF-SCREEN IS THE OTHER HALF OF THE GLITCH. setInterval keeps
       firing while the section is out of view (and browsers throttle it in a
       background tab), so returning to the page could land mid-transition or
       fire a burst of queued steps. Pause when it leaves the viewport and when
       the tab is hidden; resume WITHOUT re-measuring, so position is preserved. */
    if (window.IntersectionObserver) {
      var vis = true;
      new IntersectionObserver(function (entries) {
        vis = entries[0].isIntersecting;
        if (vis && document.visibilityState !== 'hidden') play();
        else stop();
      }, { rootMargin: '80px' }).observe(root);
      document.addEventListener('visibilitychange', function () {
        if (document.visibilityState === 'hidden') stop();
        else if (vis) play();
      });
    }
    if (mqMobile.addEventListener) mqMobile.addEventListener('change', refresh);

    // run after layout settles so measurements are correct
    requestAnimationFrame(refresh);
  }

  function boot(scope) { (scope || document).querySelectorAll('[data-ehp-fon]').forEach(init); }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', function () { boot(); });
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:section:select', function (e) { boot(e.target); });
})();
